import { fetchConToken  } from "../helpers/fetch";

const MedicosAbmService = {
  guardarMedico: (medicos) =>{
    return fetchConToken(`EfectorP`, medicos, "POST")
  },
  actualizarMedico: (medicos) =>{
    return fetchConToken(`EfectorP`, medicos, "PUT")
  }
}

export { MedicosAbmService as default }